//
export default [
    {
        text: "dirección",
        value: "address",
    },
    {
        text: "correo electrónico",
        value: "email",
    },
    {
        text: "teléfono",
        value: "phone",
    },
]